import { render } from "./IconArrowBackTracking.vue?vue&type=template&id=163431ca"
import script from "./IconArrowBackTracking.vue?vue&type=script&lang=ts"
export * from "./IconArrowBackTracking.vue?vue&type=script&lang=ts"
script.render = render

export default script